import { Form } from 'react-final-form'
import { makeStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'
import Button from '../../../control/button/button'

import MyTextfield from '../../../control/textfield/textfield'

import Select from '../../../control/select/select'

import useTranslate from '../../../i18n/useTranslate'
import useUserGroup from '../../../services/um/lookups/useUsergroup'
import ConstantUserGroup from '../../../constants/userGroup'
import useAuthenStore from '../../../stores/authen/authenStore'

interface Props {
    initialValues?: any
    onSearch: (values: any) => void
    onReset: () => void
    onEnter: (values: any) => void
}

const Panel: React.FC<Props> = ({ initialValues, onSearch, onReset, onEnter }) => {
    const classes = useStyles()
    const t = useTranslate()
    const { userGroup } = useUserGroup()
    const authenStore = useAuthenStore()
    const groupID = authenStore.profile.userGroupId

    const lang = t.languageStore.currentLanguage as 'th' | 'en'
    const lutUserGroup = userGroup
        .map((item) => ({
            value: item.id.toString(),
            label: lang === 'en' ? item.name_en : item.name_th,
        }))
        .filter((item) => {
            if (groupID === ConstantUserGroup.researcher) {
                //ถ้า user เป็นนักวิจัยดูได้
                return item
            } else {
                //เจ้าหน้าที่เพิ่มนักวิจัยไม่ได้ ต้องสมัครมาเอง
                return item.value !== ConstantUserGroup.researcher.toString() && item
            }
        })

    return (
        <Form onSubmit={onSearch} initialValues={initialValues}>
            {({ handleSubmit, form, values }) => (
                <Grid className={classes.root}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={8}>
                            <MyTextfield
                                name="keyword"
                                materialInputProps={{
                                    label: t.get('UM.USERGROUP.OFFICER.SEARCH-LABEL'),
                                    disabled: false,
                                    placeholder: t.get('UM.USERGROUP.SEARCH-PLACEHOLDER'),
                                    size: 'small',
                                }}
                                onEnter={() => onEnter(values)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Select
                                name="usergroupID"
                                option={lutUserGroup}
                                label={t.get('UM.USERGROUP.OFFICER.USERGROUP-LABEL')}
                                placeholder={t.get('UM.USERGROUP.OFFICER.USERGROUP-LABEL')}
                                defaultValue={initialValues.usergroupID}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container justify="flex-end" spacing={2}>
                            <Grid item>
                                <Button
                                    size={'large'}
                                    fullWidth
                                    variant="contained"
                                    color="default"
                                    onClick={() => {
                                        const param = {
                                            usergroupID: null,
                                            keyword: null,
                                        }
                                        form.initialize(param)
                                        onReset()
                                    }}
                                    className={classes.btnSearch}
                                >
                                    {t.get('BUTTON.RESET')}
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    size={'large'}
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSubmit}
                                    className={classes.btnSearch}
                                >
                                    {t.get('BUTTON.SEARCH')}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </Form>
    )
}

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(3),
        border: '1px solid #bdbdbd',
        borderRadius: 4,
    },
    action: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    button: {
        marginLeft: theme.spacing(2),
    },

    root: {
        padding: '15px',
    },
    btnSearch: {
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
    },
}))

export default Panel
